import { useFormContext } from 'react-hook-form';

import { Box, Checkbox, InsetInput, u } from '@ui';

import { LiveAnalysisFormValues } from './schema';

const asNumber = (value: unknown) => (value === '' ? undefined : Number(value));

export const LiveAnalysisConfig = () => {
    const form = useFormContext<LiveAnalysisFormValues>();
    const regDelayError = form.formState.errors.regDelay;
    const iterationError = form.formState.errors.iterations;
    return (
        <Box display="flex" gap={u(1)} alignItems="center" justifyContent="space-between">
            <InsetInput
                label="P1 Registration Delay*"
                {...form.register('regDelay', { setValueAs: asNumber })}
                error={regDelayError?.message}
            />
            <InsetInput
                label="Iterations (optional)"
                {...form.register('iterations', {
                    setValueAs: asNumber,
                })}
                error={iterationError?.message}
            />
            <Checkbox label="Autostart" modal {...form.register('autoRestart')} />
        </Box>
    );
};
